import React, { useState, useEffect } from 'react';
import { Box, IconButton, Paper } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const CustomCarousel = ({ images }) => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = images.length;
  const [isPaused, setIsPaused] = useState(false);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => (prevActiveStep - 1 + maxSteps) % maxSteps);
  };

  // Auto-play cada 4 segundos
  useEffect(() => {
    let timer;
    if (!isPaused) {
      timer = setInterval(handleNext, 4000);
    }
    return () => clearInterval(timer);
  }, [activeStep, isPaused]);

  return (
    <Box 
      sx={{ width: '100%', position: 'relative', overflow: 'hidden', mt: 1 }}
      onMouseEnter={() => setIsPaused(true)}  // Pausa al entrar
      onMouseLeave={() => setIsPaused(false)} // Resume al salir
    >
      
      <Box
        sx={{
          display: 'flex',
          transition: 'transform 0.5s ease-in-out',
          transform: `translateX(-${activeStep * 100}%)`,
        }}
      >
        {images.map((step, index) => (
          <Box
            key={index}
            component="img"
            sx={{
              display: 'block',
              maxWidth: '100%',
              overflow: 'hidden',
              width: '100%',
              objectFit: 'cover',
              flexShrink: 0,
            }}
            src={step.url}
            alt={`banner-${index}`}
          />
        ))}
      </Box>

      {/* Botones de Navegación */}
      <IconButton
        onClick={handleBack}
        sx={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', bgcolor: 'rgba(255,255,255,0.5)', '&:hover': { bgcolor: 'white' } }}
      >
        <ArrowBackIosNewIcon />
      </IconButton>
      <IconButton
        onClick={handleNext}
        sx={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', bgcolor: 'rgba(255,255,255,0.5)', '&:hover': { bgcolor: 'white' } }}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      {/* Indicadores (puntitos) */}
      <Box sx={{ position: 'absolute', bottom: 10, width: '100%', display: 'flex', justifyContent: 'center', gap: 1 }}>
        {images.map((_, index) => (
          <Box
            key={index}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: activeStep === index ? '#242c59' : 'rgba(255,255,255,0.8)',
              transition: '0.3s',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CustomCarousel;